import qs from 'query-string';
import { BASE_URL } from '../config';
import customFetch from './../../function/customFetch';
import axios from './../../function/axiosInstance';
import extract from './../../function/extract';
const url = `${BASE_URL}/users`;
const companyUrl = `${BASE_URL}/companies`;
export const fetchUser = async ({ id }) => {
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await axios.get(`/users/${id}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchUserDetails = async ({ id }) => {
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await axios.get(`/users/${id}/details`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchRecommendedUsers = async (assignmentIDs, projectId, fetchMargin) => {
    try {
        if (!Array.isArray(assignmentIDs))
            throw new Error('assignmentIds must be an array');
        if (assignmentIDs.length === 1) {
            const [assignmentID] = assignmentIDs;
            const response = await axios.get(`/recommendations/v3?assignment_id=${assignmentID}&fetch_margin=${fetchMargin}`);
            return extract.data(response);
        }
        if (projectId === '')
            throw new Error('projectID must be present for multiple assignments');
        const params = qs.stringify({
            assignment_ids: assignmentIDs,
            project_id: projectId
        }, { arrayFormat: 'comma' });
        const response = await axios.get(`recommendations/bulk?${params}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const editDetails = async ({ id, body }) => {
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await axios.put(`${url}/${id}/details`, body);
        return {
            status: 'ok',
            description: response.data.description
        };
    }
    catch (error) {
        return {
            status: 'error',
            description: extract.error(error).error
        };
    }
};
export const findLocationByZipCode = async ({ zipCode }) => {
    try {
        const axios = await import('axios').then(m => m.default);
        const response = await axios(`https://api.postalpincode.in/pincode/${zipCode}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const editUserRole = async ({ id, role }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${url}/${id}/role`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({ role })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.description,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const fetchList = async ({ query_params = {}, page = 0, page_size = 10, fetchAll = false }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    if (!fetchAll) {
        reqQueryParams.append('current_page', page.toString());
        reqQueryParams.append('page_size', page_size.toString());
    }
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${url}?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0
            },
            error: error.message
        };
    }
};
export const fetchOrganizationsList = async ({ query_params = {}, page = 0, page_size = 10, fetchAll = false }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    if (!fetchAll) {
        reqQueryParams.append('current_page', page.toString());
        reqQueryParams.append('page_size', page_size.toString());
    }
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${companyUrl}?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0
            },
            error: error.message
        };
    }
};
export const onboardUsers = async (user_list, operation, message) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/onboarding-status`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({
                ids: user_list,
                status: operation,
                ...(message && { onboarding_message: message })
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.description,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const companyDetails = async (body) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${companyUrl}`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const getCompanyPrefillData = async (id) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await axios
            .get(`${companyUrl}/${id}/prefill-biodata`, { headers })
            .then(response => {
            response.data.data = response.data.prefill_biodata;
            return response;
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const editCompanyDetails = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${companyUrl}/${id}`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const fetchTeamMemberList = async ({ id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${companyUrl}/${id}/team-members`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: [],
            error: error.message
        };
    }
};
export const addTeamMembers = async ({ body, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${companyUrl}/${id}/team-members`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.points,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const createContract = async ({ id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${url}/${id}/contracts`, {
            headers,
            method: 'POST',
            body: JSON.stringify({})
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const fetchContracts = async ({ id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${url}/${id}/contracts`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const selectManager = async ({ body, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${companyUrl}/${id}/managers`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const editClientStatus = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${companyUrl}/${id}/status`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const editClientAccountType = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${companyUrl}/${id}/type`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const updateGenreVerticals = async ({ body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/requests`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const fetchChangeHistory = async ({ query_params = {}, page = 0, page_size = 10, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    reqQueryParams.append('page', page.toString());
    reqQueryParams.append('page_size', page_size.toString());
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.append(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${url}/${id}/requests?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            const next_page = result.total_records - page_size * (page + 1) > 0 ? page + 1 : null;
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records,
                    next_page
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0,
                next_page: null
            },
            error: error.message
        };
    }
};
export const fetchRequestList = async ({ query_params = {}, page = 0, page_size = 100 }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    reqQueryParams.append('page', page.toString());
    reqQueryParams.append('page_size', page_size.toString());
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${url}/requests?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0
            },
            error: error.message
        };
    }
};
export const fetchUserRequestList = async ({ query_params = {}, page = 0, page_size = 100, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    reqQueryParams.append('page', page.toString());
    reqQueryParams.append('page_size', page_size.toString());
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${url}/${id}/requests?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0
            },
            error: error.message
        };
    }
};
export const acceptRejectRequest = async ({ body, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/requests/${id}`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const fetchUserRequestMetrics = async () => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        const response = await customFetch(`${url}/requests/metrics`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                open_requests: 0,
                closed_requests: 0,
                total_requests: 0
            },
            error: error.message
        };
    }
};
export const updateStatusToContractSigned = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await customFetch(`${BASE_URL}/users/${id}/details`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                description: result.description
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            description: error.message
        };
    }
};
export const updateEmailPreferences = async ({ companyId, body }) => {
    try {
        const response = await axios.put(`/companies/${companyId}/preferences`, body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getCompanyAdditionalSettings = async ({ id }) => {
    try {
        const response = await axios.get(`/companies/${id}/settings`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const updateCompanyAdditionalSettings = async ({ id, body }) => {
    try {
        const response = await axios.put(`/companies/${id}/settings`, body);
        return extract.data(response.data);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchCompanyDetails = async (id, includeFilter = false) => {
    try {
        const response = await axios.get(`${companyUrl}/${id}?include_filters=${+includeFilter}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const checkReferral = async ({ body, id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${BASE_URL}/refer`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.points,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const deleteUser = async ({ id }) => {
    try {
        const response = await axios.delete(`/users/${id}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getReviewAndRatingsList = async ({ user_Id, query_params = {}, page = 0, page_size = 7 }) => {
    const reqQueryParams = new URLSearchParams();
    reqQueryParams.append('current_page', page.toString());
    reqQueryParams.append('page_size', page_size.toString());
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await axios.get(`/assignments?${reqQueryParams.toString()}&stage=approved&sort_by=allotted_date&sort_order=desc&client_feedback=true&user_id=${user_Id}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchUserBadges = async ({ id }) => {
    try {
        if (!id)
            throw new Error('Please login again');
        const response = await axios.get(`/users/${id}/badges`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
//# sourceMappingURL=users.js.map